import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class DecryptionService {
  decryptRequestBody(reqBody: string, key: string, iv: string) {
    const decryptedBytes = CryptoJS.AES.decrypt(
      reqBody,
      CryptoJS.enc.Utf8.parse(key),
      {
        keySize: 256 / 8,
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }
}
